import React, { useContext, useEffect } from 'react'
import { Button, Typography } from 'mobily-ui-library/lib';
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../context/GlobalContext';
import OrderDetails from '../../components/OrderDetails/OrderDetails';

import Router from '../../assets/Router.svg';

import Success from '../../assets/SuccessMark.svg';

import './FTTHSuccess.scss';

const win: any = window;

function FTTHSuccess() {
    const { t } = useTranslation();

    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, requestFlow } = state;

    useEffect(() => {
        dispatch({ type: 'SET_LOADER', payload: false });
    }, [dispatch]);

    const handleRedirect = () => {
        window.location.href = win['base_portal_url'] + win['ftth_track_order_url']
    }

    return (
        <main className='FTTH__SuccessContainer'>

            <div className='DCS__Section'>
                <section className='DCS__HeadingSection'>
                    <img src={Success} alt='success' />
                    <div className='DCS__Subheading'>
                        <Typography className='title'>{t('Demand_Request_Submission_title')}</Typography>
                        <Typography className='subTitle'>{t('Demand_Request_Submission_SMS')}</Typography>
                    </div>
                </section>

                <OrderDetails />

                <div className='line' />

                <section className='DCS__TrackingSection'>
                    <div className='DCS__Track'>
                        <Typography rtl={rtl} className='track-title'>{t('What_happens')}</Typography>

                        <div className='Track__Details'>
                            <img className='TD__Img' src={Router} alt='router' />
                            {requestFlow === 'installation' && <>
                                <div className='TD__Description'>
                                    <Typography rtl={rtl} className='title'>{t('Track_request')}</Typography>
                                    <Typography rtl={rtl} className='sub-title'>{t('Please_click_on_the_below_link_to_monitor_your_request')}</Typography>
                                </div>
                                <Button rtl={rtl} className='FTTH__Success__MButton' onClick={handleRedirect}>{t('Track_request')}</Button>
                            </>}
                            {requestFlow !== 'installation' && <>
                                <div className='TD__Description'>
                                    <Typography rtl={rtl} className='title'>{t('Request_Review')}</Typography>
                                    <Typography rtl={rtl} className='sub-title'>{t('Request_Submit_Regulator')}</Typography>
                                    <Typography rtl={rtl} className='sub-title'>{t('Request_Enough_Demand')}</Typography>
                                </div>
                            </>}
                        </div>
                    </div>
                </section>
            </div>
        </main>
    )
}

export default FTTHSuccess